/** @format */

import React, { FunctionComponent, ReactElement, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import I18n from '../../components/Translate/I18n';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { useDispatch } from 'react-redux';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { usePlatformResellerHeaders, usePlatformResellerList } from '../../modules/lib/hooks/usePlatformResellerHooks';
import { SimpleSelect } from '../../components/Adescom/SimpleSelect';
import MvnoBlockListInterface from '../../interfaces/platform/MvnoBlockListInterface';
import { DateHelperTs } from '../../helpers/DateHelperTs';

type MvnoBlockListCloneDialogType = {
    open: boolean;
    blockName: string | null;
    blockId: number | null;
    closeCallback(): void;
    reloadCallback(): void;
};

export const MvnoBlockListCloneDialog: FunctionComponent<MvnoBlockListCloneDialogType> = ({
    open,
    closeCallback,
    reloadCallback,
    blockName,
    blockId,
}): ReactElement => {
    const dispatch = useDispatch();
    const platformResellers = usePlatformResellerList([
        { name: 'deleted', value: 0 },
        { name: 'active', value: 1 },
    ]);
    const platformResellerHeader = usePlatformResellerHeaders(platformResellers);
    const [platformResellerId, setPlatformResellerId] = useState<number | null>(null);

    const cloneBlock = (): void => {
        const newBlock = {
            blockName: blockName ?? '',
            platformResellerId: platformResellerId,
            platformReseller: 'none',
            defaultGlobal: false,
            deleted: false,
            createdAt: DateHelperTs.getCurrentDateSimple(),
            deletedAt: null,
            clone: true,
            cloneId: blockId,
        } as MvnoBlockListInterface;
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.postWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_block_lists')),
            'mvno_block_lists_post',
            newBlock,
            (data: MvnoBlockListInterface): void => {
                reloadCallback();
                closeCallback();
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    const setPlatformResellerCallback = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        setPlatformResellerId(parseInt(event.target.value));
    };

    return (
        <Dialog open={open} maxWidth="xs" fullWidth={true}>
            <DialogTitle id="alert-dialog-title">
                <I18n trans="prov:vb.clone_block_dialog" valueObject={{ block_name: blockName }} />
            </DialogTitle>
            <DialogContent>
                <GridContainer>
                    <GridItem xs={12}>
                        <SimpleSelect
                            label="prov:features.platform_reseller"
                            required={true}
                            elements={platformResellerHeader ?? []}
                            fieldName="platformResellerId"
                            dispatchName={'none'}
                            selectedValue={platformResellerId ?? undefined}
                            callback={setPlatformResellerCallback}
                        />
                    </GridItem>
                </GridContainer>
                <br />
            </DialogContent>
            <DialogActions>
                <CustomTextButtom callback={closeCallback} callbackParam={{}} label="general:common.close" size="sm" />
                <CustomTextButtom callback={cloneBlock} callbackParam={{}} label="general:common.save" size="sm" />
            </DialogActions>
        </Dialog>
    );
};
